/**
 * Trust strip — placeholder operator/builder logos.
 * Each is a hand-rolled monochrome SVG glyph in the cyan-friendly palette.
 * Replace with real logos when available (see PRD.md "Placeholder Content").
 */
const LOGOS = [
    {
        name: "ATLAS",
        glyph: (
            <svg viewBox="0 0 120 28" className="h-5 w-auto" fill="none">
                <path d="M2 22 L12 4 L22 22 M5 16 H19" stroke="currentColor" strokeWidth="1.6" strokeLinecap="square" />
                <text x="30" y="20" fontFamily="Geist, sans-serif" fontSize="13" fontWeight="600" letterSpacing="3" fill="currentColor">ATLAS</text>
            </svg>
        ),
    },
    {
        name: "VESSEL",
        glyph: (
            <svg viewBox="0 0 130 28" className="h-5 w-auto" fill="none">
                <path d="M3 6 L13 22 L23 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="square" strokeLinejoin="miter" />
                <text x="32" y="20" fontFamily="Geist, sans-serif" fontSize="13" fontWeight="600" letterSpacing="3" fill="currentColor">VESSEL</text>
            </svg>
        ),
    },
    {
        name: "CIPHER",
        glyph: (
            <svg viewBox="0 0 130 28" className="h-5 w-auto" fill="none">
                <circle cx="13" cy="14" r="9" stroke="currentColor" strokeWidth="1.6" />
                <path d="M13 5 V14 L19 18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="square" />
                <text x="32" y="20" fontFamily="Geist, sans-serif" fontSize="13" fontWeight="600" letterSpacing="3" fill="currentColor">CIPHER</text>
            </svg>
        ),
    },
    {
        name: "GUNMETAL",
        glyph: (
            <svg viewBox="0 0 150 28" className="h-5 w-auto" fill="none">
                <rect x="3" y="6" width="20" height="16" stroke="currentColor" strokeWidth="1.6" />
                <line x1="3" y1="14" x2="23" y2="14" stroke="currentColor" strokeWidth="1.6" />
                <text x="32" y="20" fontFamily="Geist, sans-serif" fontSize="13" fontWeight="600" letterSpacing="3" fill="currentColor">GUNMETAL</text>
            </svg>
        ),
    },
    {
        name: "BADGES",
        glyph: (
            <svg viewBox="0 0 130 28" className="h-5 w-auto" fill="none">
                <path d="M13 4 L22 9 V19 L13 24 L4 19 V9 Z" stroke="currentColor" strokeWidth="1.6" />
                <circle cx="13" cy="14" r="3" stroke="currentColor" strokeWidth="1.6" />
                <text x="32" y="20" fontFamily="Geist, sans-serif" fontSize="13" fontWeight="600" letterSpacing="3" fill="currentColor">BADGES</text>
            </svg>
        ),
    },
];

export default function TrustStrip() {
    return (
        <section
            id="trust"
            data-testid="trust-strip"
            className="relative bg-tca-deep border-y border-tca-ink-dim/25"
        >
            <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 py-12 sm:py-16">
                <div className="font-label text-tca-ink-muted/85 text-center" data-testid="trust-label">
                    Trusted by Operators, Builders &amp; Creators
                </div>

                <div
                    className="mt-8 sm:mt-10 flex flex-wrap items-center justify-center gap-x-10 sm:gap-x-14 gap-y-6 text-tca-ink-muted/80"
                    data-testid="trust-logos"
                >
                    {LOGOS.map((l) => (
                        <div
                            key={l.name}
                            className="opacity-70 hover:opacity-100 hover:text-tca-cyan transition-all duration-500"
                            data-testid={`trust-logo-${l.name.toLowerCase()}`}
                            aria-label={l.name}
                        >
                            {l.glyph}
                        </div>
                    ))}
                </div>

                {/* Cyan thin underline divider */}
                <div className="mt-12 sm:mt-14 mx-auto h-px max-w-[440px] bg-gradient-to-r from-transparent via-tca-cyan/45 to-transparent" />
            </div>
        </section>
    );
}
